import { computed, toValue } from "vue";

/**
 * Pairs each result with the element its finder kind draws it with and the properties the kind hands that element.
 * A result whose `resultType` the kind does not map is left out and reported, never drawn with a guessed element.
 *
 * @param {Array} records the results
 * @param {Object} kind the finder's kind definition
 * @param {Object} context `{ payload, settings }` the kind builds the properties from
 */
export function useResultElements(records, kind, context) {
  function withElement(result) {
    const definition = toValue(kind);
    const tag = definition?.results?.[result.resultType];
    if (!tag) {
      console.error(`The ${definition?.name} finder has no element for result type "${result.resultType}"`);
      return undefined;
    }
    return { result, tag, properties: definition.resultProperties({ result, ...toValue(context) }) };
  }

  return computed(() => toValue(records).map(withElement).filter(Boolean));
}
